import Link from 'next/link';
import { SITEMAP } from '../../../../config/sitemap';
import ButtonWithIcon from '../../../molecules/ButtonWithIcon';
import LogoWithTitle from '../../../molecules/LogoWithTitle';
import RegisterForm, {
  RegisterFormSchema,
} from '../../../organisms/RegisterForm/registerform';
import { ReturnWrapper, StepOneWrapper } from '../register.styled';

interface RegisterStepOneProps {
  onContinue: (values: RegisterFormSchema) => void;
  initialValues?: RegisterFormSchema;
}

const RegisterStepOne = (props: RegisterStepOneProps) => {
  return (
    <StepOneWrapper>
      <LogoWithTitle title='Create an Account' />
      <RegisterForm
        onSubmit={(values) => {
          props.onContinue(values);
        }}
        initialValues={props.initialValues}
      />
      <ReturnWrapper>
        <Link href={SITEMAP.LOGIN}>
          <ButtonWithIcon size={'lg'} variant={'subtle'} iconName={'leftArrow'}>
            RETURN TO LOGIN
          </ButtonWithIcon>
        </Link>
      </ReturnWrapper>
    </StepOneWrapper>
  );
};

export default RegisterStepOne;
